import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/site/Reveal";

const CHAIN = ["Problema", "Estrategia", "Tecnología", "Resultado"];

export const ValueProp = () => (
  <section className="relative py-28 md:py-40" data-testid="value-prop">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <h2 className="max-w-4xl text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight">
          La tecnología no debería hacer más <span className="text-gradient">complejo</span> tu negocio.
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-7 max-w-2xl text-base md:text-lg text-[var(--muted)] leading-relaxed">
          Diseñamos soluciones digitales que convierten procesos complejos en sistemas simples, inteligentes y escalables.
        </p>
      </Reveal>
      <div className="mt-14 flex flex-wrap items-center gap-3" data-testid="value-chain">
        {CHAIN.map((step, i) => (
          <Reveal key={step} delay={0.15 + i * 0.12} className="flex items-center gap-3">
            <span className="rounded-full border border-[var(--line)] bg-[var(--surface)] px-6 py-3 text-sm font-semibold tracking-wide">
              <span className="mono mr-2 text-[11px] text-[var(--green)]">0{i + 1}</span>
              {step}
            </span>
            {i < CHAIN.length - 1 && <ArrowRight size={16} className="text-[var(--cyan)]" aria-hidden="true" />}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
